<template>
	<div class="header">
		<div class="left">
			<div class="header-sidebar-btn" @click="toggleSideBar">
				<span class="iconfont icon-RectangleCopy"></span>
				<label>目录</label>
			</div>
			<div class="header-title">{{title}}</div>
		</div>
		<div class="right">
			<a class="blue" href="javascript:void(0);" @click="openWithHbuilder" >使用HBuilderX打开课程源码</a>
			<a class="green" :href="askUrl" @click="toAsk" target="_blank">讨论本课内容</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NavBar',
		props: {
			title: {
				type: String,
				default () {
					return ''
				}
			},
			askUrl: {
				type: String,
				default () {
					return ''
				}
			},
			downUrl: {
				type: String,
				default () {
					return ''
				}
			}
		},
		methods: {
			toggleSideBar() {
				this.$emit('toggleSideBar')
			},
			openWithHbuilder(){
				this.$emit('openWithHbuilder')
			},
			toAsk(){
				// eslint-disable-next-line
				if(_hmt){
					// eslint-disable-next-line
					_hmt.push(['_trackEvent', 'Link', 'toAsk', '讨论本课内容']);
				}
			}
		}
	}
</script>

<style scoped>
	.header {
		width: 100%;
		height: 60px;
		font-size: 16px;
		background-color: #1d1d1d;
		color: #999999;
	}

	.left {
		display: inline-block;
		text-align: left;
	}

	.right {
		float: right;
		line-height: 60px;
		display: inline-block;
		text-align: left;
	}
	
	.right a {
		display: inline-block;
		height: 60px;
		line-height: 60px;
		float: right;
		text-align: center;
		padding: 0px 20px;
		color: white;
	}

	.header-sidebar-btn {
		display: inline-block;
		height: 100%;
		vertical-align: middle;
		line-height: 60px;
		text-align: center;
		margin-left: 10px;
		color: white;
	}

	.header-sidebar-btn label {
		margin-left: 5px;
	}

	.header-title {
		display: inline-block;
		max-width: 300px;
		height: 60px;
		vertical-align: middle;
		line-height: 60px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin-left: 20px;
	}
</style>
